import type { ActionsReadModel, ActionsReadModelItem } from './governance-api'

export type ActionPresentationState = 'requires_action' | 'waiting' | 'information'

export function actionPresentationState(action: Pick<ActionsReadModelItem, 'state'>): ActionPresentationState {
  if (action.state === 'open') return 'requires_action'
  if (['waiting_on_others', 'blocked', 'pending_recipient', 'unassigned'].includes(action.state)) return 'waiting'
  return 'information'
}

export function actionSummaryCounts(model: Pick<ActionsReadModel, 'totalCount' | 'actionableCount' | 'waitingOnOthersCount'> | undefined) {
  const requiresAction = model?.actionableCount ?? 0
  const waiting = model?.waitingOnOthersCount ?? 0
  return {
    requiresAction,
    waiting,
    information: Math.max(0, (model?.totalCount ?? 0) - requiresAction - waiting),
  }
}

export function groupActionsByPresentationState(items: ActionsReadModelItem[]) {
  return items.reduce<Record<ActionPresentationState, ActionsReadModelItem[]>>((groups, item) => {
    groups[actionPresentationState(item)].push(item)
    return groups
  }, { requires_action: [], waiting: [], information: [] })
}
